import { STATUS_TYPE } from '../../../enum';
import { Flavor } from '../../flavor/api/interface';
import { Shape } from '../../shape/api/interface';
import { ToppingsCategoryItem } from '../../toppingsCategoryItem/api/interface';

export interface CakesInterface {
  id: string;
  labelEn: string;
  labelAr: string;
  descriptionEn: string;
  descriptionAr: string;
  colorCode: string;
  isNew: boolean;
  isMostLoved: boolean;
  isSoldOut: boolean;
  displayBackgroundColor: string;
  displayMode: string;
  position: number;
  shapeId: string;
  flavorId: string;
  toppingId: string;
  totalQuantitySold: string;
  flavor: Flavor;
  shape: Shape;
  topping_category_item: ToppingsCategoryItem;
}

export interface ToppingsInterface {
  id: string;
  code: string;
  labelEn: string;
  labelAr: string;
  descriptionEn: string;
  descriptionAr: string;
  isNew: boolean;
  price: number;
  discountedPrice: number;
  previewUrl: string;
  totalQuantitySold: string;
}

export interface AddonInterface {
  id: string;
  labelEn: string;
  labelAr: string;
  descriptionEn: string;
  descriptionAr: string;
  previewUrl: string;
  stock: number;
  price: number;
  discountedPrice: number;
  position: number;
  totalQuantitySold: string;
}

export interface ShapesInterface {
  labelEn: string;
  labelAr: string;
  previewUrl: string;
  totalQuantitySold: string;
}
export interface FindSellingCakeReport {
  timePeriod: string;
  startDate?: string;
  endDate?: string;
}

export interface SellingCakeReport {
  topSellingCakes: CakesInterface[];
  lessSellingCakes: CakesInterface[];
  topSellingToppings: ToppingsInterface[];
  lessSellingToppings: ToppingsInterface[];
  topSellingAddon: AddonInterface[];
  lessSellingAddon: AddonInterface[];
  topSellingShapes: ShapesInterface[];
  lessSellingShapes: ShapesInterface[];
}

export interface InitialState {
  data: SellingCakeReport | null;
  skip: number;
  limit: number;
  totalRecords: number;
  currentPage: number;
  status: STATUS_TYPE;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  errorMessage: string;
}

export const initialState: InitialState = {
  data: null,
  skip: 0,
  limit: 5,
  totalRecords: 0,
  currentPage: 0,
  status: 'idle',
  isError: false,
  isLoading: false,
  isSuccess: false,
  errorMessage: '',
};